import { c as _c } from "react/compiler-runtime";
import { PromotionPriceDisplay } from "../promotion-price-display";
import { Fragment, type ReactNode } from "react";
import { formatCurrency } from "@/lib/format-data";
import { formatDurationRange } from "@/lib/provider-service-duration";
export interface PricingInfo {
  displayPrice: number | undefined;
  displayPriceMax: number | undefined;
  priceStartsAt: boolean | undefined;
  estimated: boolean | undefined;
  originalDisplayPrice?: number | null;
  originalDisplayPriceMax?: number | null;
  promotionName?: string | null;
}
interface PriceDisplayProps {
  pricing: PricingInfo;
  bookingFee: number;
  showBookingFee: boolean;
  bookingFeeAutoToCredit?: boolean;
  duration: number;
  /** Longest time when providers differ; shows "30–45min". */
  durationMax?: number;
  showDuration: boolean;
  variant?: "mobile" | "desktop";
  /** Shown before the price, e.g. "+" on an add-on. */
  prefix?: string;
}
export const PriceDisplay = t0 => {
  const $ = _c(18);
  const {
    pricing,
    bookingFee,
    showBookingFee,
    bookingFeeAutoToCredit,
    duration,
    durationMax,
    showDuration,
    variant: t1,
    prefix
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const isMobile = variant === "mobile";
  const priceClasses = isMobile ? "text-body font-medium tabular-nums text-foreground" : "text-body-lg font-medium tabular-nums text-foreground";
  const durationClasses = isMobile ? "text-body tabular-nums text-foreground-muted" : "text-caption tabular-nums text-foreground-muted text-right";
  const t2 = durationMax ?? duration;
  let t3;
  if ($[0] !== duration || $[1] !== t2) {
    t3 = formatDurationRange(duration, t2);
    $[0] = duration;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const durationLabel = `${t3}min`;
  const bookingFeeLabel = bookingFeeAutoToCredit ? "deposit" : "booking fee";
  const Wrapper = isMobile ? Fragment : StackedWrapper;
  let t4;
  if ($[3] !== bookingFee || $[4] !== bookingFeeLabel || $[5] !== prefix || $[6] !== priceClasses || $[7] !== pricing || $[8] !== showBookingFee) {
    t4 = (pricing.displayPrice ?? 0) > 0 || !!pricing.displayPriceMax || !!pricing.originalDisplayPrice ? <span className={priceClasses}>{prefix}<PromotionPriceDisplay pricing={pricing} /></span> : showBookingFee ? <span className={priceClasses}>{formatCurrency(bookingFee)} {bookingFeeLabel}</span> : null;
    $[3] = bookingFee;
    $[4] = bookingFeeLabel;
    $[5] = prefix;
    $[6] = priceClasses;
    $[7] = pricing;
    $[8] = showBookingFee;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== durationClasses || $[11] !== durationLabel || $[12] !== showDuration) {
    t5 = showDuration && <span className={durationClasses}>{durationLabel}</span>;
    $[10] = durationClasses;
    $[11] = durationLabel;
    $[12] = showDuration;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== Wrapper || $[15] !== t4 || $[16] !== t5) {
    t6 = <Wrapper>{t4}{t5}</Wrapper>;
    $[14] = Wrapper;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
const StackedWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col items-end">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
interface BookingFeeNoteProps {
  showBookingFee: boolean;
  displayPrice: number | undefined;
  bookingFee: number;
  bookingFeeAutoToCredit?: boolean;
  variant?: "mobile" | "desktop";
}
export const BookingFeeNote = t0 => {
  const $ = _c(6);
  const {
    showBookingFee,
    displayPrice,
    bookingFee,
    bookingFeeAutoToCredit,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  if (!showBookingFee || !(displayPrice && displayPrice > 0)) {
    return null;
  }
  const feeLabel = bookingFeeAutoToCredit ? "deposit" : "booking fee";
  let t2;
  if ($[0] !== bookingFee || $[1] !== feeLabel || $[2] !== variant) {
    t2 = variant === "mobile" ? `(${formatCurrency(bookingFee)} ${feeLabel})` : `${formatCurrency(bookingFee)} ${feeLabel} required`;
    $[0] = bookingFee;
    $[1] = feeLabel;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const text = t2;
  let t3;
  if ($[4] !== text) {
    t3 = <span className="text-caption text-foreground-muted">{text}</span>;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};